import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const AppLoadingView = ({
    title = "Loading",
    description = "Preparing your workspace. Please wait.",
    icon: Icon = InfoOutlinedIcon,
}) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                minHeight: "100dvh", // mobile-safe
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "background.default",
                px: 2,
            }}
        >
            <Paper
                elevation={theme.shadows ? 4 : 0}
                sx={{
                    p: theme.spacing(4),
                    width: "100%",
                    maxWidth: 420,
                    textAlign: "center",
                    borderRadius: theme.shape.borderRadius,
                }}
            >
                <Stack spacing={theme.spacing(3)} alignItems="center">
                    {/* Context Icon */}
                    <Box
                        sx={{
                            width: theme.spacing(7),
                            height: theme.spacing(7),
                            borderRadius: "50%",
                            bgcolor: "primary.light",
                            color: "primary.contrastText",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Icon fontSize="medium" />
                    </Box>

                    {/* Title */}
                    <Typography variant="h6" color="text.primary">
                        {title}
                    </Typography>

                    {/* Spinner */}
                    <CircularProgress />

                    {/* Description */}
                    <Typography
                        variant="body2"
                        color="text.secondary"
                    >
                        {description}
                    </Typography>

                    {/* Reassurance */}
                    <Stack
                        direction="row"
                        spacing={theme.spacing(1)}
                        alignItems="center"
                    >
                        <CheckCircleOutlineIcon
                            fontSize="small"
                            sx={{ color: "success.main" }}
                        />
                        <Typography
                            variant="caption"
                            color="text.secondary"
                        >
                            No action required
                        </Typography>
                    </Stack>
                </Stack>
            </Paper>
        </Box>
    );
};

export default AppLoadingView;